import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonReset.module.scss'

const ButtonReset = () => {
  return (
    <div className={styles.buttonResetContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'forgot-password-button-reset'}
            defaultMessage={'Reset'}
          />
        )}
        customClassnames={{container: styles.button}}
      />
    </div>
  );
};

export default ButtonReset;
